export const obtenerValorPorcentaje = ({total, porcentaje=0}) =>{

    if (porcentaje === 0){
        return 0
    }

    return (porcentaje * total / 100).toFixed(0)
}